export default {
  title: 'Import of invoices. Import result',
  table: {
    file: 'File',
    provider: 'Provider',
    client: 'Client',
    number: 'Invoice number',
    ammount: 'Amount',
    result: 'Result',
    comment: 'Comment'
  },
  correct: 'Correct invoices',
  incorrect: 'Rejected invoices',
  notTreated: 'Untreated invoices',
  total: 'Total invoices',
  error: 'The import has failed. Check the incorrect invoices. No invoice has been registered. To continue press OK.',
  partialError: 'The import has failed. Check the incorrect invoice. Invoice {0} has not been registered. To continue press OK. | The import has failed. Check the incorrect invoice. Invoices {0} have not been registered. To continue press OK.',
  success: 'The import has been completed. Invoice {0} has been imported. To continue press OK. | The import has been completed. {0} Invoices have been imported. To continue press OK.'
}
